import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';

import EstensaModel, { BusinessUnit, Examination, Provenance } from 'estensa-module';
import { ServerRootService } from '../../utils/routing/serverroot.service';
import { Observable, catchError, map, of } from 'rxjs';
import { Logger } from '@se/se.platform.base';

export const ESTENSA_MODULE_RADIOLOGY_COMMON_SERVICE = new InjectionToken('estensa.module.radiology.common.service');

export interface Html5CollectionMethods {
    GetAllProvenances: Provenance[];
    GetBusinessUnits: BusinessUnit[];
    GetProvenances: Provenance[];
}

type BaseDataResponse<T> = {
    success: boolean;
    message: string;
    data: T | null;
};



/**
 * Wrapper per le chiamate alle collection - potrebbero essere in cache nel vecchio client?
 */
export type IRadiologyCommonServiceNg1 = {
    [method in keyof Html5CollectionMethods as Uncapitalize<method>]: () => {
        $promise: Promise<Html5CollectionMethods[method]>;
    };
};

export class NullRadiologyCommonService implements IRadiologyCommonServiceNg1 {
    getAllProvenances = () => ({ $promise: Promise.resolve([]) });
    getBusinessUnits = () => ({ $promise: Promise.resolve([]) });
    getProvenances = () => ({ $promise: Promise.resolve([]) });
}

/**
 * Per le chiamate semplici, invece di creare un wrapper, le eseguiamo direttamente da angular.
 */
@Injectable({
    providedIn: 'root',
})
export class RadiologyCommonService {
    constructor(
        private http: HttpClient,
        private serverRoot: ServerRootService,
        private logger: Logger,
    ) {}

    getFullExamination(examinationId: string) {
        return this.http.get<Examination>(`${this.serverRoot.getServerRoot()}/RadiologyCommon/GetFullExamination`, {
            ...this.serverRoot.buildOptions(),
            params: { examinationId },
        });
    }

    getSexes(): Observable<BaseDataResponse<EstensaModel.Sex[]>> {
        return this.http
            .get<
                EstensaModel.Sex[]
            >(`${this.serverRoot.getServerRoot()}/RadiologyCommon/GetSexes`, this.serverRoot.buildOptions())
            .pipe(
                map((response: EstensaModel.Sex[]) => {
                    return {
                        success: true,
                        message: 'Success',
                        data: response,
                    };
                }),
                catchError((error) => {
                    this.logger.error(error);
                    return of({
                        success: false,
                        message: error,
                        data: null,
                    });
                }),
            );
    }

    getModalities(): Observable<BaseDataResponse<EstensaModel.CodeDescriptionItem[]>> {
        return this.http
            .get<
            EstensaModel.CodeDescriptionItem[]
            >(`${this.serverRoot.getServerRoot()}/RadiologyCommon/getDicomModalities`, this.serverRoot.buildOptions())
            .pipe(
                map((response: EstensaModel.CodeDescriptionItem[]) => {
                    return {
                        success: true,
                        message: 'Success',
                        data: response,
                    };
                }),
                catchError((error) => {
                    this.logger.error(error);
                    return of({
                        success: false,
                        message: error,
                        data: null,
                    });
                }),
            );
    }
    
}
